import { useState } from "react";
import { OrderTrayFilter } from "../fragments.dispatches/OrderTrayFilter";
import { OrderTrayList } from "../fragments.dispatches/OrderTrayList";
import { OrderDispatchReceived } from "../fragments.dispatches/OrderDispatchReceived";
import { ConfirmDispatchForm } from "../fragments.dispatches/ConfirmDispatchForm";

const initialDispatch = {
    operationID: 0, clientID: 0, userID: 0, warehouseID: 0,
    observation: "Anulado por cancelación de la compra por parte del cliente",
    operationStatus: "", documentType: "", physicalDistribution: "",
    total: 0, paymentMethods: {}, details: [],
};

export function OrderTrayPage() {
    const [orders, setOrders]     = useState([]);
    const [gangs, setGangs]       = useState([]);
    const [users, setUsers]       = useState([]);
    const [filename, setFilename] = useState("ReporteBandejaPedidos");
    const [detailsFromOrderDispatchReceived, setDetailsFromOrderDispatchReceived] = useState([]);
    const [dispatchToConfirm, setDispatchToConfirm] = useState(initialDispatch);
    const [showDetailsModal, setShowDetailsModal]   = useState(false);
    const [showConfirmModal, setShowConfirmModal]   = useState(false);
    const [searchFn, setSearchFn] = useState(null);

    const [dailyRouteStatus] = useState([
        { id: "04", name: "ENVIO PENDIENTE" },
        { id: "05", name: "ENVIADO" },
        { id: "06", name: "ENTREGADO CONFORME" },
        { id: "07", name: "ENVIO FALLIDO" },
        { id: "08", name: "ENVIO ANULADO" },
    ]);

    return (
        <>
            {/* Page header */}
            <section className="mb-6">
                <div className="max-w-full px-4">
                    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                        <h1 className="text-2xl font-bold text-gray-900 dark:text-white tracking-tight">
                            Bandeja de pedidos de preventa
                        </h1>
                        <nav aria-label="breadcrumb">
                            <ol className="flex items-center gap-2 text-sm">
                                <li className="text-blue-600 dark:text-blue-400">Distribuciones</li>
                                <li className="text-gray-400 dark:text-gray-500 select-none">/</li>
                                <li className="text-gray-700 dark:text-gray-300 font-medium">Listado</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </section>

            <section>
                <div className="max-w-full px-4 space-y-4">
                    <OrderTrayFilter
                        setOrders={setOrders}
                        gangs={gangs}
                        setGangs={setGangs}
                        users={users}
                        setUsers={setUsers}
                        dailyRouteStatus={dailyRouteStatus}
                        setFilename={setFilename}
                        ordersCount={orders.length}
                        registerSearchFn={setSearchFn}
                    />
                    <OrderTrayList
                        setOrders={setOrders}
                        orders={orders}
                        filename={filename}
                        setDetailsFromOrderDispatchReceived={setDetailsFromOrderDispatchReceived}
                        setShowDetailsModal={setShowDetailsModal}
                        dispatchToConfirm={dispatchToConfirm}
                        setDispatchToConfirm={setDispatchToConfirm}
                        setShowConfirmModal={setShowConfirmModal}
                        onRefresh={searchFn}
                    />
                </div>
            </section>

            <OrderDispatchReceived
                detailsFromOrderDispatchReceived={detailsFromOrderDispatchReceived}
                isOpen={showDetailsModal}
                onClose={() => setShowDetailsModal(false)}
            />
            <ConfirmDispatchForm
                dispatchToConfirm={dispatchToConfirm}
                setDispatchToConfirm={setDispatchToConfirm}
                isOpen={showConfirmModal}
                onClose={() => setShowConfirmModal(false)}
                onRefresh={searchFn}
            />
        </>
    );
}
